import { motion } from "framer-motion";
import { useInView } from "framer-motion";
import { useRef } from "react";

export default function SectionTitle({
  title,
  subtitle,
  description,
  align = "center",
  light = false,
  className = "",
}) {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.5 });

  const alignClasses = {
    center: "text-center mx-auto",
    left: "text-left",
    right: "text-right ml-auto",
  };

  return (
    <div ref={ref} className={`max-w-3xl ${alignClasses[align]} ${className}`}>
      {subtitle && (
        <motion.span
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5 }}
          className={`
            inline-block px-4 py-1.5 mb-4
            text-sm font-semibold tracking-wider uppercase
            rounded-full
            ${
              light
                ? "bg-white/20 text-white"
                : "bg-primary-100 text-primary-700"
            }
          `}
        >
          {subtitle}
        </motion.span>
      )}

      <motion.h2
        initial={{ opacity: 0, y: 30 }}
        animate={isInView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.6, delay: 0.1 }}
        className={`
          text-3xl md:text-4xl lg:text-5xl font-bold
          leading-tight
          ${light ? "text-white" : "text-dark-900"}
        `}
      >
        {title}
      </motion.h2>

      {description && (
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.5, delay: 0.2 }}
          className={`
            mt-4 text-lg md:text-xl
            ${light ? "text-white/80" : "text-dark-500"}
          `}
        >
          {description}
        </motion.p>
      )}

      {/* Animated line decoration */}
      <motion.div
        initial={{ scaleX: 0 }}
        animate={isInView ? { scaleX: 1 } : {}}
        transition={{ duration: 0.8, delay: 0.3 }}
        className={`
          mt-6 h-1 w-24 rounded-full origin-left
          ${align === "center" ? "mx-auto" : ""}
          ${align === "right" ? "ml-auto" : ""}
          bg-gradient-to-r from-primary-500 to-teal-500
        `}
      />
    </div>
  );
}
